import { render, staticRenderFns } from "./Carousels.vue?vue&type=template&id=715653f4&"
import script from "./Carousels.vue?vue&type=script&lang=js&"
export * from "./Carousels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports